import {popupSubscription} from '@/utils/helper';
import styles from './PersonaItem.module.scss';
import {sendClickLog} from '@/utils/main/my-plus/log';

const PersonaItem = ({imageUrl, personaName, personaId, userId}) => {
  const onSubscriptionClick = () => {
    popupSubscription({
      bj_id: personaId,
      bj_profile_image: imageUrl,
      user_id: userId,
      bj_nick: personaName,
    });
    sendClickLog('soopi_front', {
      button_type: 'soopi_event_streamer_icon',
      location: 'event',
      bj_id: personaId,
    });
  };

  return (
    <li className={styles.container} onClick={onSubscriptionClick}>
      <a href='#n' className={styles.thumb}>
        <img src={imageUrl} alt={`${personaName} 이미지`} />
        <span className={styles.gudok}>구독</span>
      </a>
      <span className={styles.nick}>{personaName}</span>
    </li>
  );
};

export default PersonaItem;
